export default __webpack_public_path__ + "static/media/MarkFinckle-min.825464eb.jpg";